// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"af5eeef7","207":"0032f5ce","229":"409d745f","235":"9f74ae6b","298":"a2a878d4","364":"728de142","453":"d52c9e71","546":"d9a5f49b","572":"62decb0a","613":"e1fb7bf3","650":"70ca5604","653":"5cb10c90","738":"5a85285f","768":"0de71314","899":"f296034f","978":"2e162bf1"}[chunkId] + ".chunk.js";
};